export default __webpack_public_path__ + "static/media/logo.23c76a36.svg";